import { HttpClient, HttpEvent, HttpEventType, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConfigService } from '../../../ConfigService';
import { LoadingService } from '../../../shared/loading/loading.service';
import { Certificado } from '../Modelos/Modelos/certificado';

@Injectable({
  providedIn: 'root'
})
export class CertificadoService {
  fileBlob: any;
  constructor(private http: HttpClient) { }
  changeFile(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}
  subircertificado(file: File,certificado:Certificado) : Observable<Certificado>{
    console.log(JSON.stringify(certificado))
    const formData = new FormData();
   formData.append('ruc', certificado.ruc);
   formData.append('idcopmpania', certificado.idcompania.toString());
   formData.append('fecha', certificado.fecha);
   formData.append('clave', certificado.clave);
  formData.append('file', file,file.name);
 return  this.http.post<Certificado>(ConfigService.settings.apiUrlemision + 'Certificado/UploadCertificado',formData)

  }


}
